import 'rxjs/add/observable/of';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import loadBoardConfig from '../../services/load-board-config/index.tsx';
import type { BoardConfigModel } from '../../services/load-board-config/types.tsx';
import { makeServiceContext } from '../../services/service-context/index.tsx';
import {
	LOAD_CONFIG_DATA_REQUEST,
	loadConfigDataFailure,
	loadConfigDataModelSuccess,
} from '../../state/actions/app/index.tsx';
import type { MiddlewareAPI, ActionsObservable, Action } from '../../state/types.tsx';

/**
 * @deprecated Remove when jsw-backlog-preload-config-data is cleaned up
 */
export const loadConfigDataEpicCmp = (
	action$: ActionsObservable,
	store: MiddlewareAPI,
): Observable<Action> =>
	action$
		.ofType(LOAD_CONFIG_DATA_REQUEST)
		.mergeMap(() => loadBoardConfig(makeServiceContext(store.getState())))
		.mergeMap(
			(response: BoardConfigModel): Observable<Action> =>
				Observable.of(loadConfigDataModelSuccess(response)),
		)
		.catch((error) => {
			log.safeErrorWithoutCustomerData(
				'backlog.load-config-data-cmp.failure',
				'Failed to load config data for CMP',
				error,
			);
			return Observable.of(loadConfigDataFailure());
		});
